<p-floatLabel variant="on">
    <p-datepicker appendTo="body" [iconDisplay]="'input'" [showIcon]="true" dateFormat="dd/mm/yy"
        [disabled]="disabled || readOnly" (blur)="onTouched()" (onInput)="aplicarMascara($event)"
        (onSelect)="onCalendarChange($event)" [ngModel]="value" [readonlyInput]="readOnly" [minDate]="minDate ?? null"
        [maxDate]="maxDate ?? null" class="calendar-full" [showTime]="true" hourFormat="24"
        [ngClass]="{ 'invalid': isInvalid }"></p-datepicker>
    <label>
        {{ label }}
    </label>
</p-floatLabel>
<div style="height: 22px;"></div>